export default {
  computed: {
    categoryName() {
      if (this.$route.params && this.$route.params.id &&
          this.albumCategories && this.albumCategories.length > 0) {
        const categoryName = this._.find(this.albumCategories,
            {id: this.$route.params.id});

        if (categoryName && categoryName.title) {
          return categoryName.title;
        }
      }

      return '';
    },
  },
  created() {
    this.$store.dispatch('INIT_ALBUMS', {id: this.$route.params.id, vm: this});
  },
};
